import { render, staticRenderFns } from "./ObjectFitWrapper.vue?vue&type=template&id=338bbd6e&"
import script from "./ObjectFitWrapper.vue?vue&type=script&lang=js&"
export * from "./ObjectFitWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ObjectFitWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports